import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

import sharedReducer, { SharedState } from "./reducers/shared";
import highFrequencyWordReducer, {
  HighFrequencyWordState,
} from "./reducers/highFrequencyWord";
import contentWordReducer, { ContentWordState } from "./reducers/contentWord";
import blendingReducer, { BlendingState } from "./reducers/blending";
import phonemeReducer, { PhonemeState } from "./reducers/phoneme";

const isProduction = process.env.NODE_ENV === "production";

export interface State {
  shared: SharedState;
  highFrequencyWord: HighFrequencyWordState;
  contentWord: ContentWordState;
  phoneme: PhonemeState;
  blending: BlendingState;
}

const rootReducer = combineReducers({
  shared: sharedReducer,
  highFrequencyWord: highFrequencyWordReducer,
  contentWord: contentWordReducer,
  phoneme: phonemeReducer,
  blending: blendingReducer,
});

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleWare = isProduction
  ? applyMiddleware(thunk)
  : composeEnhancers(applyMiddleware(thunk));

const store = createStore(rootReducer, middleWare);

export default store;
